import * as Yup from 'yup';
import { Writer } from '@models';

export function useValidationSchema() {
  return Yup.object<Writer>().shape({
    contact: Yup.string().nullable().required(),
  });
}
